import React from 'react';
import { Link } from 'react-router-dom';
import {capitalizeFirstLetter} from '../../utils/letters'

function News({ newsData, isLoading, limitHome }) {
    const noticias = Array.isArray(newsData) ? newsData : [];

    return (
        <>
            <section className="tittle-news">
                {limitHome && (
                    <Link to="/noticias" className="btn-ver-todos btn-ver-todos-news">
                        <i className="ri-menu-search-line d-inline d-md-none"></i>
                        <span className="d-none d-md-inline">Ver todas las noticias</span>
                    </Link>
                )}
                
                <div className="tittle-news-right">
                    <div className="div-news">
                        <span>Última información</span>
                        <i className="ri-megaphone-fill mega-icon"></i>
                    </div>
                    <div className="titt-n">
                        <span>Noticias</span>
                    </div>
                </div>
            </section>

            <section className="carousel-wrapper">
                {isLoading ? (
                    <div className="loader-container">
                        <img src="/icon/carga-puntos.svg" alt="Cargando..." style={{ width: '180px' }} />
                        <p className="txt-loading">Buscando novedades...</p>
                    </div>
                ) : (
                    <>
                        {noticias.length > 0 && (
                            <button className="nav-arrow left" onClick={() => document.querySelector('.section-news-container').scrollBy({ left: -350, behavior: 'smooth' })}>
                                <i className="ri-arrow-left-s-line"></i>
                            </button>
                        )}

                        <section className="section-news-container">
                            {noticias.length > 0 ? (
                                noticias.map((news) => (
                                    <div className="news-card" key={news.id}>
                                        <div className="img-wrapper">
                                            <img src={news.imagen_portada || news.imagen_url || "/img/course/1.wepb"} alt={news.titulo} />
                                        </div>
                                        <span className="date-card-n">{news.fecha_formateada || news.fecha || "Reciente"}</span>
                                        <div className="card-content-news">
                                            <p className="news-name">{capitalizeFirstLetter(news.titulo)}</p>
                                            <span className="news-txt">{capitalizeFirstLetter(news.bajada || news.resumen)}</span>
                                            <div className="news-info-row">
                                                <Link to={`/noticia/${news.slug || news.id}`}>
                                                    <span>Leer más</span>
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                ))
                            ) : (
                                <span className="txt-resp">No hay noticias disponibles en este momento.</span>
                            )}
                        </section>

                        {noticias.length > 0 && (
                            <button className="nav-arrow right" onClick={() => document.querySelector('.section-news-container').scrollBy({ left: 350, behavior: 'smooth' })}>
                                <i className="ri-arrow-right-s-line"></i>
                            </button>
                        )}
                    </>
                )}
            </section>
        </>
    );
}

export default News;